import type { EComDataType } from '~/stores/cartStore/model';
import type { ProductFinderAttribution } from '~/utils/productFinderAnalytics/types';
import { getProductFinderAttributionForSku } from '~/utils/productFinderAnalytics/getProductFinderAttributionForSku';

function getPrimaryFinderAttribution(
  items: ReadonlyArray<Record<string, unknown>>
): ProductFinderAttribution | undefined {
  for (const item of items) {
    const sku = String(item.item_id ?? '');
    if (!sku) {
      continue;
    }

    const attribution = getProductFinderAttributionForSku(sku);
    if (attribution) {
      return attribution;
    }
  }

  return undefined;
}

export function enrichEcommerceWithFinderAttribution(
  ecommerce: EComDataType,
  source?: string
): EComDataType {
  const enrichedItems = ecommerce.items.map((item) => {
    const sku = String(item.item_id ?? '');
    const attribution = sku
      ? getProductFinderAttributionForSku(sku)
      : undefined;

    if (!attribution) {
      return item;
    }

    return {
      ...item,
      item_list_id: attribution.item_list_id,
      item_list_name: attribution.item_list_name,
      selected_via_finder: attribution.selected_via_finder,
      finder: attribution.finder,
      finder_entry: attribution.finder_entry,
      finder_session_id: attribution.finder_session_id,
      ...(attribution.finder_camera_sku
        ? { finder_camera_sku: attribution.finder_camera_sku }
        : {})
    };
  });

  const hasFinderItems = enrichedItems.some(
    (item) => item.selected_via_finder === true
  );
  const primaryAttribution = getPrimaryFinderAttribution(enrichedItems);
  const isProductFinderSource = source === 'productFinder' || hasFinderItems;

  if (!isProductFinderSource || !primaryAttribution) {
    return {
      ...ecommerce,
      items: enrichedItems
    };
  }

  return {
    ...ecommerce,
    ecom_source: 'productFinder',
    finder: primaryAttribution.finder,
    finder_entry: primaryAttribution.finder_entry,
    finder_session_id: primaryAttribution.finder_session_id,
    items: enrichedItems
  };
}
